import React from 'react';
import './TrackList.css';

import Track from '../../components/Track/Track.js';

class TrackList extends React.Component {
  render() {
   return (
     <div className="TrackList">
       {this.props.tracks.map(track => <Track key={track.id} track={track} onRemove={this.props.onRemove} onAdd={this.props.onAdd} />)}
     </div>
   );
 }
}

export default TrackList;



// WEBPACK FOOTER //
// ./src/components/TrackList/TrackList.js